export const appLinkSections = {
  Reports: 'chart area',
};
